import { z } from "zod";
import { AbstractEtlValidationSchema } from "./abstractEltValidation.entities";
import { AwIdSchema, SetterSchema } from "types/src/traits";

export const AbstractDictionnarySchema = AbstractEtlValidationSchema
	.merge(AwIdSchema)
	.merge(SetterSchema)
	.merge(z.object({}));

export type AbstractDictionnary = z.infer<typeof AbstractDictionnarySchema>